import type { LC_ShiftGroupItem, ShiftGroup } from './shiftGroups.types';


export function mapShiftGroupOutToModel(item: LC_ShiftGroupItem): ShiftGroup {
  return {
    id: item.shiftGroupId,
    name: item.shiftGroup,
  };
}
